import React from "react";
import {
  Briefcase,
  Search,
  Sparkles,
  Bell,
  Users,
  FileSearch,
  MessagesSquare,
} from "lucide-react";

import ProductPage from "../Components/ProductPage";
import JobsHero from "../Components/JobsHero";
import { colors as DS } from "../../design-system";

export default function ProductJobs() {
  return (
    <ProductPage
      meta={{ code: "JOBS" }}
      heroOverride={
        <JobsHero
          ctaPrimary={{ label: "Browse jobs", href: "/jobs" }}
          ctaSecondary={{ label: "Create profile", href: "/jobs/auth" }}
        />
      }
      hero={{
        title: (
          <>
            Jobs that find you,
            <br />
            <span style={{ color: `${DS.forest}80` }}>not the other way round.</span>
          </>
        ),
        subtitle: "AI-Powered Job Portal",
        description:
          "A candidate-first job portal predictive matching, smart applications and a chatbot that actually answers your questions at 11pm.",
        accent: DS.product.jobs,
        icon: Briefcase,
        animation: "robot",
      }}
      features={{
        title: "Built for the modern job seeker.",
        subtitle: "Less doom-scrolling, more interview invites.",
        items: [
          {
            icon: Sparkles,
            title: "Predictive fit scoring",
            description: "Each role shows a match score against your skills, experience and goals not just keyword overlap.",
          },
          {
            icon: Search,
            title: "Smart search & filters",
            description: "Salary, remote-readiness, visa, work-auth and skill-graph filters that actually work.",
          },
          {
            icon: FileSearch,
            title: "One-click apply",
            description: "Profile-driven applications with cover-letter scaffolding generated from the JD.",
          },
          {
            icon: Bell,
            title: "Live alerts",
            description: "Push, email and SMS the moment a strong match is posted within seconds, not hours.",
          },
          {
            icon: MessagesSquare,
            title: "Candidate chatbot",
            description: "Ask anything about a role, the company or your application status. 24/7, no queue.",
          },
          {
            icon: Users,
            title: "Verified employers",
            description: "Every employer is verified and rated apply with confidence, not blind hope.",
          },
        ],
      }}
      flow={{
        title: "From interest to offer in four steps.",
        stages: [
          { title: "Discover",  desc: "AI surfaces roles you would have missed on a job board." },
          { title: "Apply",     desc: "One-click submission with role-specific cover letter." },
          { title: "Engage",    desc: "Chat, schedule and prep all inside the portal." },
          { title: "Onboard",   desc: "Accept, sign and start handed off to the company's HRMS." },
        ],
      }}
      stats={{
        title: "Outcomes for candidates this quarter.",
        items: [
          { value: "85%", label: "match accuracy" },
          { value: "4.7×", label: "more interviews per applicant" },
          { value: "9 d",  label: "median offer cycle" },
          { value: "24/7", label: "ai assistant uptime" },
        ],
      }}
      ctaPrimary={{ label: "Browse jobs",     href: "/jobs" }}
      ctaSecondary={{ label: "Create profile", href: "/jobs/auth" }}
      finalCta={{
        title: (
          <>
            Find your next role.
            <br />
            <span style={{ color: `${DS.forest}80` }}>Faster, smarter, kinder.</span>
          </>
        ),
        subtitle: "Build a profile once. Get matched to the right roles, automatically.",
        ctaPrimary:   { label: "Get started",       href: "/jobs/auth" },
        ctaSecondary: { label: "Explore the suite", href: "/products" },
      }}
    />
  );
}
